<template>
	<div>
		<div v-if="isUserAllowedInLevel2">
			<div v-if="doneFetchingCompany">
				<PremiumLawyerOfficeProfileForm v-model="model" :company-type="$t('lawyers_office')">
					<template #buttons>
						<div class="w-full flex justify-start">
							<BaseButton @click="goBack" class="mr-4">
								{{ $t('general.back') }}
							</BaseButton>
						</div>
					</template>
				</PremiumLawyerOfficeProfileForm>
			</div>
		</div>

		<div v-else>
			<Forbidden />
		</div>
	</div>
</template>

<script>
import { CompanyApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden';
import BaseButton from '@/components/forms/buttons/BaseButton';
import PremiumLawyerOfficeProfileForm from '@/views/premiumpartners/PremiumLawyerOfficeProfileForm.vue';

export default {
	name: 'PremiumLawyerOfficeProfile',
	components: {
		PremiumLawyerOfficeProfileForm,
		BaseButton,
		Forbidden,
	},
	mixins: [Authentication],
	data() {
		return {
			model: {
				bankAccount: {},
				ownerFirstname: null,
				ownerLastname: null,
				city: {},
			},
			doneFetchingCompany: false,
		};
	},
	created() {
		if (this.isUserAllowedInLevel2 || this.isAuthenticatedUserInGroupAdmin) {
			this.getCompanyProfileData(this.$route.params?.id || this.getUser.person?.company?.company_id || this.getUser.person?.company?.id);
		}
	},
	methods: {
		getCompanyProfileData(id) {
			CompanyApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.companyIdGet(id)
				.then(response => {
					this.model = response.data;
					this.doneFetchingCompany = true;
				})
				.catch(() => {
					this.doneFetchingCompany = true;
				});
		},
		goBack() {
			if (this.$route.params.backlink) {
				this.$router.push(this.$route.params.backlink);
				return;
			}

			this.$router.push({ name: 'premiumpartners' });
		},
	},
};
</script>
